import { cva } from 'class-variance-authority';

export const cvaPayment = cva([
  'PaymentStyles-cvaPayment',
  'relative z-[102] ',
  'h-screen overflow-auto',
  'bg-[#070417]',
  'px-2.4',
  'overflow-x-clip ',
]);

export const cvaPaymentBlock = cva([
  'PaymentStyles-cvaPayment',
  'px-2.4 py-2',
  'flex flex-col gap-1.2',
  '[&>div>span]:text-[1.6rem] [&>div>span]:text-[#7C7B83] [&_p>span]:text-cGreen',
]);

export const cvaPaymentForm = cva([
  'PaymentStyles-cvaPaymentForm',
  'flex flex-col gap-1.2',
  'w-full',
  'bg-[#070417]',
  '-mt-6',
  //  'h-screen overflow-scroll',
]);

export const cvaPaymentFormTitle = cva([
  'PaymentStyles-cvaPaymentFormTitle',
  'text-[2rem] font-bold',
]);

export const cvaPaymentFormText = cva([
  'PaymentStyles-cvaPaymentFormText',
  'text-m-sb',
]);

export const cvaPaymentInfo = cva([
  'PaymentStyles-cvaPaymentInfo',
  'flex gap-0.6',
  'text-[1.6rem] font-semibold',
  '[&>span]:w-9.2 [&>span]:min-w-9.2 [&>span]:text-[#7C7B83] [&>p>span]:text-cGreen',
  'pt-1.2 border-t-[3px] border-t-[#373541]',
  'not-last:pb-1.2 not-last:border-none not-last:pt-0',
]);

export const cvaPaymentInfoField = cva([
  'PaymentStyles-cvaPaymentInfoField',
  'block',
  'min-w-[9rem]',
  'text-m-sb text-cGray',
]);

export const cvaPaymentInfoDescription = cva([
  'PaymentStyles-cvaPaymentInfoDescription',
  'block',
  'mr-1.6',
  'text-m-sb text-cGray text-center',
]);
